module.exports = "<label *ngIf=\"label\"\r\n       class=\"pad-right-8\">{{label}}:</label>\r\n<div class=\"text-box-container\">\r\n    <div *ngIf=\"showPlaceholder\"\r\n         class=\"text-box-placeholder\">\r\n        {{placeholder}}\r\n    </div>\r\n    <input [(ngModel)]=\"value\" />\r\n</div>\r\n<tooltip *ngIf=\"tooltip\">\r\n    {{tooltip}}\r\n</tooltip>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client-src/app/core/components/text-box/text-box.component.html
// module id = ./client-src/app/core/components/text-box/text-box.component.html
// module chunks = main